'use strict';export default{silentJSONParsing:true,forcedJSONParsing:true,clarifyTimeoutError:false};